// extracted by mini-css-extract-plugin
export default {"container":"Stacks_container__Tmjwt","innerContainer":"Stacks_innerContainer__Vy87i","col":"Stacks_col__MzvV+","stack":"Stacks_stack__0hNki"};